import DropTargetWrapperContainer from '../../../containers/dnd/DropTargetWrapperContainer'

const ListDropZone = ({
    listId,
    itemType, 
    dndType = false,
    wrapper,
    canDropCallback=false,
    addItem
}) => (
    <DropTargetWrapperContainer
        listID={listId}
        items={[]}
        selectionType='newsletter'
        pushItem={addItem}
        dndType={dndType ? dndType : itemType}
        wrapper={wrapper}
        canDropCallback={canDropCallback}
    >
        <div className="periode-item-dropbox">
            <div className="periode-item-dropbox-inner"></div>
        </div>
    </DropTargetWrapperContainer>
)

export default ListDropZone